export default "__VITE_ASSET__DoQ0ZxUf__"